import { AddStaffBody, AddStaffQuery, staffsApis } from '@apis/dashboard/staffApis';
import { useMutation } from '@hooks/useMutation';
import { FormError } from '@utils/errors';

export const useAddStaff = () => {
  return useMutation(async ({ query, body }: { query: AddStaffQuery; body: AddStaffBody }) => {
    const response = await staffsApis.post('/dashboard/staff/', { query, body });
    if (response[400]) {
      throw new FormError('AddStaffError', response[400]);
    }
    return response[201]!;
  });
};
